import(/* webpackMode: "eager", webpackExports: ["Location"] */ "/app/apps/web/app/components/location/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactActions"] */ "/app/apps/web/app/components/vehicle/details/contact/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/app/components/vehicle/details/galery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DetailsHeader"] */ "/app/apps/web/app/components/vehicle/details/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/apps/web/modules/ui/components/accordion.tsx");
